<template>
  <div class="blog-container">
    <header class="blog-header">
      <h1 class="title">
        REPARACIONES DE IPAD PARA ESCUELAS Y UNIVERSIDADES EN TODO ESTADOS UNIDOS
      </h1>
      <p class="meta">📅 21 de agosto | ✍️ Mark Keller | 💬 22 Comentarios</p>
    </header>

    <main class="blog-main">
      <!-- Imagen a la izquierda -->
      <div class="image-section">
        <img src="@/assets/Img/Banners/redes_fondo.jpg" alt="Reparación de iPad" class="hero-img" />
      </div>

      <!-- Sidebar a la derecha -->
      <aside class="sidebar">
        <input type="text" placeholder="🔍 Buscar..." class="search" />
        <ul class="categories">
          <li>📱 Teléfonos inteligentes</li>
          <li>🖥️ Escritorio y Mac</li>
          <li>🎮 Consolas de juegos</li>
          <li>🔒 Seguridad y protección</li>
          <li>📁 Sin categoría</li>
        </ul>
        <div class="recent">
          🆕 <strong>Cómo limpiar las reparaciones de iPad en línea en Plymouth</strong>
        </div>
      </aside>
    </main>

    <section class="blog-content">
      <p>
        En este artículo exploramos cómo las instituciones educativas pueden acceder a servicios
        profesionales de reparación de iPads en todo Estados Unidos. Desde reemplazos de pantalla
        hasta mantenimiento preventivo, el enfoque está en mantener los dispositivos funcionando
        de forma óptima para estudiantes y profesores.
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'BlogNoticia'
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Rubik:wght@400;600&display=swap');

.blog-container {
  display: flex;
  flex-direction: column;
  padding: 2rem;
  font-family: 'Rubik', sans-serif;
  max-width: 1200px;
  margin: 0 auto;
  animation: fadeIn 0.8s ease-in;
}

.blog-header {
  text-align: center;
  margin-bottom: 1rem;
}

.title {
  font-size: 2.2rem;
  margin-bottom: 0.5rem;
  color: #1a1a1a;
  font-weight: 600;
  letter-spacing: 0.5px;
  transition: color 0.3s ease;
}

.title:hover {
  color: #0077cc;
}

.meta {
  font-size: 0.95rem;
  color: #666;
  font-style: italic;
}

.blog-main {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 2rem;
  margin-top: 2rem;
  align-items: start;
}

.image-section {
  width: 100%;
  animation: slideInLeft 0.8s ease;
}

.hero-img {
  width: 100%;
  max-height: 400px;
  object-fit: cover;
  border-radius: 10px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease;
}

.hero-img:hover {
  transform: scale(1.02);
}

.sidebar {
  background: #ffffff;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
  align-self: start;
  animation: slideInRight 0.8s ease;
}

.search {
  width: 100%;
  padding: 0.6rem;
  margin-bottom: 1rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 0.95rem;
  transition: border 0.3s ease;
}

.search:focus {
  border-color: #0077cc;
  outline: none;
}

.categories {
  list-style: none;
  padding: 0;
  margin: 0;
}

.categories li {
  margin: 0.5rem 0;
  font-size: 0.95rem;
  cursor: pointer;
  transition: color 0.3s ease;
}

.categories li:hover {
  color: #0077cc;
}

.recent {
  margin-top: 1rem;
  font-size: 0.95rem;
  color: #222;
}

.blog-content {
  margin-top: 2rem;
  font-size: 1.05rem;
  line-height: 1.7;
  color: #333;
  animation: fadeIn 1s ease;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes slideInLeft {
  from { opacity: 0; transform: translateX(-30px); }
  to { opacity: 1; transform: translateX(0); }
}

@keyframes slideInRight {
  from { opacity: 0; transform: translateX(30px); }
  to { opacity: 1; transform: translateX(0); }
}

@media (max-width: 768px) {
  .blog-main {
    grid-template-columns: 1fr;
  }

  .title {
    font-size: 1.6rem;
  }

  .hero-img {
    max-height: 300px;
  }
}
</style>
